import {
  setAuthToken,
  organizationCreate,
  organizationRead,
  organizationUpdate,
  // organizationDelete,
  organizationAddAdministrator,
  organizationRemoveAdministrator,
  organizationTeamAddAdministrator,
  organizationTeamRemoveAdministrator,
  organizationTeamAddMember,
  organizationTeamRemoveMember,
  organizationTeamSwitch,
  organizationTeamAdd,
  organizationTeamReadCurrent,
  organizationTeamResourceTransfer,
  organizationTeamResourceCount,
  organizationTeamLeave,
  organizationTeamDelete,
  organizationPlanActivate,
  organizationSubscriptionTransfer,
} from '@allevi/allevi-api-wrapper';


// Create organization
const createOrganizationAction = (name) => ({
  type: 'CREATE_ORGANIZATION',
  name,
});

const createOrganizationSuccess = (organization) => ({
  type: 'CREATE_ORGANIZATION_SUCCESS',
  organization,
});

const createOrganizationFailure = (statusCode, message) => ({
  type: 'CREATE_ORGANIZATION_FAILURE',
  statusCode,
  message,
});

export function createOrganization(name) {
  return async (dispatch) => {
    dispatch(createOrganizationAction(name));

    return organizationCreate(name)
      .then(e => {
        if (e.statusCode === 200 && e.organization) {
          dispatch(createOrganizationSuccess(e.organization));
          return { success: true, organization: e.organization };
        }
        dispatch(createOrganizationFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(createOrganizationFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Read organization
const getOrganizationAction = () => ({
  type: 'GET_ORGANIZATION',
});

const getOrganizationSuccess = (organization) => ({
  type: 'GET_ORGANIZATION_SUCCESS',
  organization,
});

const getOrganizationFailure = (statusCode, message) => ({
  type: 'GET_ORGANIZATION_FAILURE',
  statusCode,
  message,
});

export function getOrganization() {
  return async (dispatch) => {
    dispatch(getOrganizationAction());

    return organizationRead({})
      .then(e => {
        if (e.statusCode === 200 && e.organization) {
          dispatch(getOrganizationSuccess(e.organization));
          return { success: true };
        }
        dispatch(getOrganizationFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(getOrganizationFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Create team
const createTeamAction = (name) => ({
  type: 'CREATE_TEAM',
  name,
});

const createTeamSuccess = (team) => ({
  type: 'CREATE_TEAM_SUCCESS',
  team,
});

const createTeamFailure = (statusCode, message) => ({
  type: 'CREATE_TEAM_FAILURE',
  statusCode,
  message,
});

export function createTeam(name) {
  return async (dispatch) => {
    dispatch(createTeamAction(name));

    return organizationTeamAdd(name)
      .then(e => {
        if (e.statusCode === 200 && e.team) {
          dispatch(createTeamSuccess(e.team));
          return { success: true };
        }
        dispatch(createTeamFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(createTeamFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// // Delete organization (and all teams therein)
// const deleteOrganizationAction = (organization) => ({
//   type: 'DELETE_ORGANIZATION',
//   organization,
// });
//
// const deleteOrganizationSuccess = () => ({
//   type: 'DELETE_ORGANIZATION_SUCCESS',
// });
//
// const deleteOrganizationFailure = (statusCode, message) => ({
//   type: 'DELETE_ORGANIZATION_FAILURE',
//   statusCode,
//   message,
// });
//
// export function deleteOrganization(organization) {
//   return async (dispatch) => {
//     dispatch(deleteOrganizationAction(organization));
//
//     return organizationDelete({ _id: organization })
//       .then(e => {
//         if (e.statusCode === 200) {
//           dispatch(deleteOrganizationSuccess());
//           return { success: true };
//         }
//         dispatch(deleteOrganizationFailure(e.statusCode, e.message));
//         return { success: false };
//       })
//       .catch(e => {
//         dispatch(deleteOrganizationFailure(e.statusCode, e.message));
//         return { success: false };
//       });
//   };
// }

// Switch teams
const switchTeamAction = (organization, team) => ({
  type: 'SWITCH_TEAM',
  organization,
  team,
});

const switchTeamSuccess = (token) => ({
  type: 'SWITCH_TEAM_SUCCESS',
  token,
});

const switchTeamFailure = (statusCode, message) => ({
  type: 'SWITCH_TEAM_FAILURE',
  statusCode,
  message,
});

export function switchTeam(organization, team) {
  return async (dispatch) => {
    dispatch(switchTeamAction(organization, team));

    return organizationTeamSwitch(organization, team)
      .then(e => {
        if (e.statusCode === 200 && e.token) {
          dispatch(switchTeamSuccess(e.token));
          // Store token in browser storage
          sessionStorage.setItem('id_token', e.token);
          // Set token for API wrapper
          setAuthToken(e.token);
          return { success: true, token: e.token };
        }
        dispatch(switchTeamFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(switchTeamFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Add a member to a team
const addTeamMemberAction = (emails) => ({
  type: 'ADD_TEAM_MEMBER',
  team: emails,
});

const addTeamMemberSuccess = (emails) => ({
  type: 'ADD_TEAM_MEMBER_SUCCESS',
  emails,
});

const addTeamMemberFailure = (statusCode, message) => ({
  type: 'ADD_TEAM_MEMBER_FAILURE',
  statusCode,
  message,
});

export function addTeamMember(emailsArg) {
  return async (dispatch) => {
    let emails;
    if (Array.isArray(emailsArg)) {
      emails = emailsArg;
    } else {
      emails = [emailsArg];
    }

    dispatch(addTeamMemberAction(emails));

    return organizationTeamAddMember(emails)
      .then(e => {
        if (e.statusCode === 200) {
          dispatch(addTeamMemberSuccess(emails));
          return { success: true };
        }
        dispatch(addTeamMemberFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(addTeamMemberFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Remove member from a team
const removeTeamMemberAction = (emails) => ({
  type: 'REMOVE_TEAM_MEMBER',
  team: emails,
});

const removeTeamMemberSuccess = (emails) => ({
  type: 'REMOVE_TEAM_MEMBER_SUCCESS',
  emails,
});

const removeTeamMemberFailure = (statusCode, message) => ({
  type: 'REMOVE_TEAM_MEMBER_FAILURE',
  statusCode,
  message,
});

export function removeTeamMember(emailsArg) {
  return async (dispatch) => {
    let emails;
    if (Array.isArray(emailsArg)) {
      emails = emailsArg;
    } else {
      emails = [emailsArg];
    }

    dispatch(removeTeamMemberAction(emails));

    return organizationTeamRemoveMember(emails)
      .then(e => {
        if (e.statusCode === 200) {
          dispatch(removeTeamMemberSuccess(emails));
          return { success: true };
        }
        dispatch(removeTeamMemberFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(removeTeamMemberFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Add administrator to a team
const addTeamAdminAction = (emails) => ({
  type: 'ADD_TEAM_ADMIN',
  team: emails,
});

const addTeamAdminSuccess = (emails) => ({
  type: 'ADD_TEAM_ADMIN_SUCCESS',
  emails,
});

const addTeamAdminFailure = (statusCode, message) => ({
  type: 'ADD_TEAM_ADMIN_FAILURE',
  statusCode,
  message,
});

export function addTeamAdmin(emailsArg) {
  return async (dispatch) => {
    let emails;
    if (Array.isArray(emailsArg)) {
      emails = emailsArg;
    } else {
      emails = [emailsArg];
    }

    dispatch(addTeamAdminAction(emails));

    return organizationTeamAddAdministrator(emails)
      .then(e => {
        if (e.statusCode === 200) {
          dispatch(addTeamAdminSuccess(emails));
          return { success: true };
        }
        dispatch(addTeamAdminFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(addTeamAdminFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Remove administrator from a team
const removeTeamAdminAction = (emails) => ({
  type: 'REMOVE_TEAM_ADMIN',
  team: emails,
});

const removeTeamAdminSuccess = (emails) => ({
  type: 'REMOVE_TEAM_ADMIN_SUCCESS',
  emails,
});

const removeTeamAdminFailure = (statusCode, message) => ({
  type: 'REMOVE_TEAM_ADMIN_FAILURE',
  statusCode,
  message,
});

export function removeTeamAdmin(emailsArg) {
  return async (dispatch) => {
    let emails;
    if (Array.isArray(emailsArg)) {
      emails = emailsArg;
    } else {
      emails = [emailsArg];
    }

    dispatch(removeTeamAdminAction(emails));

    return organizationTeamRemoveAdministrator(emails)
      .then(e => {
        if (e.statusCode === 200) {
          dispatch(removeTeamAdminSuccess(emails));
          return { success: true };
        }
        dispatch(removeTeamAdminFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(removeTeamAdminFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Leave a team
const leaveTeamAction = () => ({
  type: 'LEAVE_TEAM',
});

const leaveTeamSuccess = () => ({
  type: 'LEAVE_TEAM_SUCCESS',
});

const leaveTeamFailure = (statusCode, message) => ({
  type: 'LEAVE_TEAM_FAILURE',
  statusCode,
  message,
});

export function leaveTeam() {
  return async (dispatch) => {
    dispatch(leaveTeamAction());

    return organizationTeamLeave()
      .then(e => {
        if (e.statusCode === 200 && e.token) {
          dispatch(leaveTeamSuccess());
          // Store token in browser storage
          sessionStorage.setItem('id_token', e.token);
          // Set token for API wrapper
          setAuthToken(e.token);
          return { success: true, token: e.token };
        }
        dispatch(leaveTeamFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(leaveTeamFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Delete a team
const deleteTeamAction = () => ({
  type: 'DELETE_TEAM',
});

const deleteTeamSuccess = () => ({
  type: 'DELETE_TEAM_SUCCESS',
});

const deleteTeamFailure = (statusCode, message) => ({
  type: 'DELETE_TEAM_FAILURE',
  statusCode,
  message,
});

export function deleteTeam() {
  return async (dispatch) => {
    dispatch(deleteTeamAction());

    return organizationTeamDelete()
      .then(e => {
        if (e.statusCode === 200 && e.token) {
          dispatch(deleteTeamSuccess());
          // Store token in browser storage
          sessionStorage.setItem('id_token', e.token);
          // Set token for API wrapper
          setAuthToken(e.token);
          return { success: true, token: e.token };
        }
        dispatch(deleteTeamFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(deleteTeamFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Get team resource info
const getTeamResourceCountAction = (teamId) => ({
  type: 'GET_TEAM_RESOURCE_COUNT',
  team: teamId,
});

const getTeamResourceCountSuccess = (teamId, resources) => ({
  type: 'GET_TEAM_RESOURCE_COUNT_SUCCESS',
  teamId,
  resources,
});

const getTeamResourceCountFailure = (statusCode, message) => ({
  type: 'GET_TEAM_RESOURCE_COUNT_FAILURE',
  statusCode,
  message,
});

export function getTeamResourceCount(teamId) {
  return async (dispatch) => {
    dispatch(getTeamResourceCountAction(teamId));

    return organizationTeamResourceCount()
      .then(e => {
        if (e.statusCode === 200 && e.resources) {
          dispatch(getTeamResourceCountSuccess(teamId, e.resources));
          return { success: true };
        }
        dispatch(getTeamResourceCountFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(getTeamResourceCountFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}

// Transfer team resources
const transferTeamResourcesAction = (organizationId, teamId) => ({
  type: 'TRANSFER_TEAM_RESOURCES',
  organization: organizationId,
  team: teamId,
});

const transferTeamResourcesSuccess = (organizationId, teamId, resources) => ({
  type: 'TRANSFER_TEAM_RESOURCES_SUCCESS',
  organizationId,
  teamId,
  resources,
});

const transferTeamResourcesFailure = (statusCode, message) => ({
  type: 'TRANSFER_TEAM_RESOURCES_FAILURE',
  statusCode,
  message,
});

export function transferTeamResources(organizationId, teamId) {
  return async (dispatch) => {
    dispatch(transferTeamResourcesAction(organizationId, teamId));

    return organizationTeamResourceTransfer(organizationId, teamId)
      .then(e => {
        if (e.statusCode === 200 && e.resources) {
          dispatch(transferTeamResourcesSuccess(organizationId, teamId, e.resources));
          return { success: true };
        }
        dispatch(transferTeamResourcesFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(transferTeamResourcesFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}


// Activate software plan with key
const activatePlanAction = (activationKey) => ({
  type: 'ACTIVATE_PLAN',
  activationKey,
});

const activatePlanSuccess = () => ({
  type: 'ACTIVATE_PLAN_SUCCESS',
});

const activatePlanFailure = (statusCode, message) => ({
  type: 'ACTIVATE_PLAN_FAILURE',
  statusCode,
  message,
});

export function activatePlan(activationKey) {
  return async (dispatch) => {
    dispatch(activatePlanAction(activationKey));

    return organizationPlanActivate(activationKey)
      .then(e => {
        if (e.statusCode === 200) {
          dispatch(activatePlanSuccess());
          return { success: true };
        }
        dispatch(activatePlanFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(activatePlanFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}


// Activate software plan with key
const transferSubscriptionAction = (organizationId) => ({
  type: 'TRANSFER_SUBSCRIPTION',
  organizationId,
});

const transferSubscriptionSuccess = () => ({
  type: 'TRANSFER_SUBSCRIPTION_SUCCESS',
});

const transferSubscriptionFailure = (statusCode, message) => ({
  type: 'TRANSFER_SUBSCRIPTION_FAILURE',
  statusCode,
  message,
});

export function transferSubscription(organizationId) {
  return async (dispatch) => {
    dispatch(transferSubscriptionAction(organizationId));

    return organizationSubscriptionTransfer(organizationId)
      .then(e => {
        if (e.statusCode === 200) {
          dispatch(transferSubscriptionSuccess());
          return { success: true };
        }
        dispatch(transferSubscriptionFailure(e.statusCode, e.message));
        return { success: false };
      })
      .catch(e => {
        dispatch(transferSubscriptionFailure(e.statusCode, e.message));
        return { success: false };
      });
  };
}
